import { SVGProps, Ref, forwardRef } from 'react';

export const DocumentArrowUpOutlinedSize32Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={32}
            height={32}
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.4 28.267V3.733h10.933c3.867 0 5.682.676 6.637 1.63.954.956 1.63 2.77 1.63 6.637v16.267zm21.6 2.4H4V1.333h13.333C25.333 1.333 28 4 28 12z"
                    fill="currentColor"
                />
                <path
                    d="M17.2 12.893v10.44h-2.4v-10.44l-3.952 3.951-1.697-1.697L16 8.298l6.848 6.849-1.697 1.697z"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
DocumentArrowUpOutlinedSize32Glyph.displayName = 'DocumentArrowUpOutlinedSize32Glyph';
